import script from "./ServiceDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailView.vue?vue&type=script&setup=true&lang=js"

import "./serviceDetail.css?vue&type=style&index=0&id=2c452b1f&scoped=true&lang=css&external"
import "../shared/routesMobileCommon.css?vue&type=style&index=1&id=2c452b1f&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c452b1f"]])

export default __exports__